import type { Directive, DirectiveBinding } from "vue"
import { parseUser } from "@/utils/parser"

/** 用户信息解析 */
export const userParse: Directive = {
  beforeMount(el, binding) {
    updateText(el, binding)
  },
  updated(el, binding) {
    updateText(el, binding)
  },
}

function updateText(el: HTMLElement, binding: DirectiveBinding) {
  const { value, modifiers } = binding
  const displayText = parseUser(value)

  // 检查是否已存在解析后的文本节点
  const existingNode = Array.from(el.childNodes).find(
    (node) => node.nodeType === Node.TEXT_NODE && (node as any).__userParsed,
  )

  if (existingNode) {
    // 如果存在，更新文本内容
    existingNode.textContent = displayText
  } else {
    // 创建新的文本节点
    const newTextNode = document.createTextNode(displayText)
    // 添加自定义属性作为标志
    ;(newTextNode as any).__userParsed = true

    // 根据修饰符决定插入位置
    if (modifiers.after) {
      el.appendChild(newTextNode)
    } else {
      el.insertBefore(newTextNode, el.firstChild)
    }
  }
}
